import Lenis from "@studio-freight/lenis";
import { type ReactNode, useEffect } from "react";

export default function LenisProvider({ children }: { children: ReactNode }) {
	useEffect(() => {
		const lenis = new Lenis({
			duration: 1.4,
			smoothWheel: true,
			syncTouch: false,
			easing: (t: number) => 1 - (1 - t) ** 3,
		});

		let rafId: number;

		function raf(time: number) {
			lenis.raf(time);
			rafId = requestAnimationFrame(raf);
		}

		rafId = requestAnimationFrame(raf);

		return () => {
			cancelAnimationFrame(rafId);
			lenis.destroy();
		};
	}, []);

	return <>{children}</>;
}
